module.exports = __webpack_public_path__ + "img/fruct25_demo.cb54895d.jpg";